import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
/* eslint-disable no-nested-ternary */
import React from 'react';
import { Message, Button, Modal, Segment, Dimmer, Loader, Image, Icon } from 'semantic-ui-react';
import gql from 'graphql-tag';
import { AuthClient } from '@emyw/core-lib';
import { normalizeErrors } from '../utils';
const sendSetPINLinkMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation ($email: String!, $origin: String!) {\n        sendSetPINLink(email: $email, origin: $origin) {\n            ok\n            errors {\n                path\n                message\n            }\n        }\n    }\n"])));
const {
  REACT_APP_ENJOY_SITE_ROOT_URL
} = process.env;
/** Update Pin Form <br /><br />
 * <hr />
 * <br />
 */
export default class UpdatePinForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSendEmail = () => {
      log.trace('**** Sending Update Pin email. user:', this.props.user);
      const {
        user
      } = this.props;
      this.setState({
        promptMessage: false
      });
      if (this.props.user) {
        AuthClient.mutate({
          mutation: sendSetPINLinkMutation,
          variables: {
            email: user.email,
            origin: REACT_APP_ENJOY_SITE_ROOT_URL
          }
        }).then(res => {
          const {
            ok,
            errors
          } = res.data.sendSetPINLink;
          if (ok) {
            this.setState({
              emailSent: true
            });
          } else {
            this.setState({
              errors: normalizeErrors(errors, 'email')
            });
          }
        });
      } else if (!this.state.errors) {
        this.setState({
          errors: [{
            message: 'No active user'
          }]
        });
      }
    };
    this.handleCloseReset = () => {
      const {
        onExit
      } = this.props;
      this.setState({
        promptMessage: true,
        errors: null
      });
      onExit();
    };
    this.state = {
      promptMessage: true,
      emailSent: false,
      errors: null
    };
  }
  render() {
    const {
      promptMessage,
      emailSent,
      errors
    } = this.state;
    const {
      open,
      onExit,
      changePinMode,
      forgotProfilePinMode,
      forgotPinMode,
      mountNode,
      dimmer
    } = this.props;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
      open: open,
      size: "tiny",
      className: "enjoyModal",
      mountNode: mountNode || undefined,
      dimmer: dimmer || true
    }, errors && !emailSent && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Header, null, "Problem Encountered"), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(Message, {
      size: "small",
      error: true
    }, /*#__PURE__*/React.createElement(Message.Header, null, "Trouble sending email. Please try again later.", /*#__PURE__*/React.createElement("br", null), "We apologize for the difficulties.")), /*#__PURE__*/React.createElement(Button, {
      type: "button",
      onClick: this.handleCloseReset,
      basic: true,
      color: "blue",
      fluid: true
    }, "OK"))), emailSent && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Header, null, "Email Sent!"), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement("p", null, "Once received, click the provided link to set your PIN."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
      type: "button",
      onClick: onExit,
      basic: true,
      color: "blue",
      fluid: true
    }, "OK"))), !errors && !promptMessage && !emailSent && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Header, null, "We're Sending you an Email"), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(Segment, null, /*#__PURE__*/React.createElement(Dimmer, {
      active: true,
      inverted: true
    }, /*#__PURE__*/React.createElement(Loader, {
      inverted: true
    }, "Sending Email...")), /*#__PURE__*/React.createElement(Image, {
      src: "https://react.semantic-ui.com/images/wireframe/short-paragraph.png"
    })), /*#__PURE__*/React.createElement(Button, {
      type: "button",
      onClick: onExit,
      basic: true,
      fluid: true
    }, "Cancel"))), !errors && promptMessage && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement(Icon, {
      name: "keyboard outline"
    }), changePinMode ? 'Change PIN' : forgotPinMode || forgotProfilePinMode ? 'Reset PIN' : 'Setup a PIN'), /*#__PURE__*/React.createElement(Modal.Content, null, changePinMode || forgotPinMode ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "We'll send you an email with a link to ".concat(changePinMode ? 'change' : 'reset', " your PIN number."))) : forgotProfilePinMode ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "You can enter your profile or account level PIN here."), /*#__PURE__*/React.createElement("p", null, "If you can't remember either, click OK below and we'll send you an email with a link to reset your account PIN. You can then update your profile PIN from your Manage Profiles page.")) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "A PIN number enables you to better control access to your account and profile settings, and provides restrictions for specific show content ratings."), /*#__PURE__*/React.createElement("p", null, "We'll send you an email with a link to enter a PIN number."))), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
      type: "button",
      onClick: onExit,
      basic: true,
      compact: true
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      type: "button",
      onClick: this.handleSendEmail,
      primary: true,
      basic: true,
      compact: true
    }, "OK")))));
  }
}
UpdatePinForm.defaultProps = {
  changePinMode: false,
  forgotPinMode: false,
  mountNode: undefined
};